import get from 'lodash.get';

const getColorPaletteConfig = (state) =>
  get(state, 'ws.template.meta.customization.colorPaletteConfig', null);

export default getColorPaletteConfig;
